/* 机房设备 */
const machine = {
    state: {
        map_data: null,
        collect: [],
        devices: [],
        var_config: [],
        temp_config: [],
    },
    mutations: {
        set_map_data: (state, info) => {
            state.map_data = info
        },
        set_collect: (state, info) => {
            state.collect = info
        },
        set_devices: (state, info) => {
            state.devices = info
        },
        set_var_config: (state, info) => {
            state.var_config = info
        },
        set_temp_config: (state, info) => {
            state.temp_config = info
        },
    },
    actions: {
        // 组态数据
        setMapData({ commit }, data) {
            commit('set_map_data', data)
        },
        // 集控器列表
        setCollect({ commit }, data) {
            commit('set_collect', data)
        },
        // 设备列表
        setDevices({ commit }, data) {
            commit('set_devices', data)
        },
        // PLC参数配置
        setVarConfig({ commit }, data) {
            commit('set_var_config', data)
        },
        // PLC模板数据
        setTempConfig({ commit }, data) {
            commit('set_temp_config', data)
        },
    }
}

export default machine
